import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'


export default class LogoTicker {
	constructor(ticker) {

		this.ticker 			= ticker;
		this.track1 			= this.ticker.querySelector('.image-ticker__group--one');
		this.track2 			= this.ticker.querySelector('.image-ticker__group--alt');
		this.init 				= this.init.bind(this)
		this.init()

	}

	init() {

		// HIDING NAV ON SCROLL USING GSAP
		const logoTickerAnimation = GSAP.to(this.track1, { 
			xPercent: -10,
			transformOrigin: "left center",
			ease: "power1.out",
			// repeat: true,
			// duration: 10,
			scrollTrigger: {
				trigger: this.track1,
				scrub: 0.1,
				start: "top bottom",
				end: "bottom -250%",
			},
		})
		const logoTickerAnimation2 = GSAP.from(this.track2, { 
			xPercent: -10,
			transformOrigin: "left center",
			ease: "power1.out",
			// repeat: true,
			// duration: 10,
			scrollTrigger: {
				trigger: this.track2,
				scrub: 0.1,
				start: "top bottom",
				end: "bottom -250%",
			},
		})

	}
}
